<template>
</template>

<script>
import { jumpWxAuth, getToken, getQueryString, configApi } from '@/utils/common'
import config from '@/utils/config'
import router from '@/router/index'
export default {
  name: 'login',
  data() {
    return {
      vid: null,
      oid: null
    }
  },
  mounted() {
    let _this = this;
    if (config.Vid) {
      this.vid = config.Vid;
    } else {
      this.vid = getQueryString('vid');
    }
    this.oid = getQueryString('oid');

    this.initData();
    return;

    let _token = getToken();
    if (_token) {
      configApi();
      if (this.oid != null) {
        router.push({
          path: "/canvass",
          query: { 'vid': this.vid, 'oid': this.oid }
        });
      } else {
        router.push({
          path: "/detail",
          query: { 'vid': this.vid }
        });
      }

    } else {
      let hasCode = jumpWxAuth();
      if (hasCode) {
        hasCode.then(() => {
          _this.initData();
        });
      }
    }
  },
  methods: {
    initData() {
      configApi();
      if (this.oid != null) {
        router.push({
          path: "/canvass",
          query: { 'vid': this.vid, 'oid': this.oid }
        });
      } else {
        router.push({
          path: "/detail",
          query: { 'vid': this.vid }
        });
      }

    }
  }
}

</script>

<style>
</style>



// WEBPACK FOOTER //
// src/pages/login/login.vue